import { isNullOrUndefined } from '@app/util/util';

export function setFormDateValue(value: string): string {
  const regEx = /^\d{4}-\d{2}-\d{2}$/;
  const match = value?.match(regEx);
  if (!isNullOrUndefined(match)) {
    const split = value?.split('-');
    return `${split[2]}/${split[1]}/${split[0]}`;
  } else {
    return value;
  }
}
